module.exports = __webpack_public_path__ + "static/media/ketoemagtramina-8.2e8e8ea3.png";